/**
 * One stage's state, as a dot. `by_design` is HOLLOW on purpose: an expected state
 * (not published yet) must never read as a failure, and grey is unknown, not zero.
 */
import React from 'react';
import type { StageName, StageState } from '@/services/productCockpitService';
import { STATE_DEFS, DEFS } from '../lib/stages';

interface StageDotProps {
  stage: StageName;
  state: StageState;
  /** true when this is the leftmost stage of the row that calls for action */
  ringed?: boolean;
}

export function StageDot({ stage, state, ringed = false }: StageDotProps) {
  const title = `${stage.toUpperCase()} — ${state}\n\n${STATE_DEFS[state] ?? ''}\n\n${DEFS[stage] ?? ''}`;
  const dot = <span className={`pmc-dot pmc-s-${state}`} />;
  return (
    <span
      className={ringed ? 'pmc-ring' : undefined}
      data-tip={title}
      aria-label={`${stage}: ${state}${ringed ? ' (first actionable stage)' : ''}`}
    >
      {dot}
    </span>
  );
}
